import { ROLES, getRoleLabel } from "../config/roles";
import { getPermissionsForRole as getDefaultPermissionsForRole } from "../config/permissions";
import { getOpsUserDisplayName, normalizePhoneNumber } from "../utils/normalizeOpsUser";
import { getRolePermissions } from "./opsRolePermissionsStore";

let nextId = 10;

function buildLocalMember({
  id,
  first_name,
  last_name,
  email,
  phone_number,
  admin_slug,
  role,
  role_slug,
  status,
  last_login_at,
  created_at,
  status_reason,
}) {
  const name = getOpsUserDisplayName({ first_name, last_name, email });
  return {
    id,
    first_name,
    last_name,
    name,
    email,
    phone_number,
    phone: normalizePhoneNumber(phone_number),
    admin_slug: admin_slug || id,
    role_slug: role_slug || role,
    role,
    permissions: getDefaultPermissionsForRole(role),
    status,
    last_login_at: last_login_at ?? null,
    created_at: created_at ?? null,
    deleted_at: null,
    invitedAt: created_at ? String(created_at).slice(0, 10) : null,
    status_reason,
  };
}

const INITIAL_OPS_USERS = [
  buildLocalMember({
    id: "ops_u_001",
    first_name: "Ama",
    last_name: "Ofori",
    email: "admin@simcollect.gh",
    phone_number: "233241112233",
    admin_slug: "ops_u_001",
    role: ROLES.SUPER_ADMIN,
    status: "active",
    last_login_at: "2026-08-07T09:15:00.000000Z",
    created_at: "2025-01-10T10:00:00.000000Z",
  }),
  buildLocalMember({
    id: "ops_u_002",
    first_name: "Efua",
    last_name: "Adom",
    email: "manager@simcollect.gh",
    phone_number: "233241112255",
    admin_slug: "ops_u_002",
    role: ROLES.CALL_CENTER_MANAGER,
    status: "active",
    last_login_at: "2026-08-07T08:42:00.000000Z",
    created_at: "2025-03-04T10:00:00.000000Z",
  }),
  buildLocalMember({
    id: "ops_u_003",
    first_name: "Grace",
    last_name: "Mensah",
    email: "agent@simcollect.gh",
    phone_number: "233241112266",
    admin_slug: "ops_u_003",
    role: ROLES.CALL_CENTER_AGENT,
    status: "active",
    last_login_at: "2026-08-06T17:20:00.000000Z",
    created_at: "2025-05-18T10:00:00.000000Z",
  }),
  buildLocalMember({
    id: "ops_u_004",
    first_name: "Nana",
    last_name: "Yaw Boadi",
    email: "exec@simcollect.gh",
    phone_number: "233241112244",
    admin_slug: "ops_u_004",
    role: ROLES.EXECUTIVE_MANAGER,
    status: "active",
    last_login_at: "2026-08-05T14:00:00.000000Z",
    created_at: "2025-02-01T10:00:00.000000Z",
  }),
  buildLocalMember({
    id: "ops_u_005",
    first_name: "Kofi",
    last_name: "Annan",
    email: "legal@simcollect.gh",
    phone_number: "233241112277",
    admin_slug: "ops_u_005",
    role: ROLES.LEGAL_OFFICER,
    status: "invited",
    last_login_at: null,
    created_at: "2026-08-01T10:00:00.000000Z",
  }),
  buildLocalMember({
    id: "ops_u_006",
    first_name: "Samuel",
    last_name: "Tetteh",
    email: "samuel.agent@simcollect.gh",
    phone_number: "233241112288",
    admin_slug: "ops_u_006",
    role: ROLES.CALL_CENTER_AGENT,
    status: "active",
    last_login_at: "2026-08-07T07:55:00.000000Z",
    created_at: "2025-06-02T10:00:00.000000Z",
  }),
  buildLocalMember({
    id: "ops_u_007",
    first_name: "Linda",
    last_name: "Appiah",
    email: "linda.agent@simcollect.gh",
    phone_number: "233241112299",
    admin_slug: "ops_u_007",
    role: ROLES.CALL_CENTER_AGENT,
    status: "active",
    last_login_at: "2026-08-07T06:40:00.000000Z",
    created_at: "2025-07-14T10:00:00.000000Z",
  }),
  buildLocalMember({
    id: "ops_u_008",
    first_name: "Michael",
    last_name: "Darko",
    email: "michael.m@simcollect.gh",
    phone_number: "233241112300",
    admin_slug: "ops_u_008",
    role: ROLES.CALL_CENTER_MANAGER,
    status: "invited",
    last_login_at: null,
    created_at: "2026-08-05T10:00:00.000000Z",
  }),
  buildLocalMember({
    id: "ops_u_009",
    first_name: "Inactive",
    last_name: "Agent",
    email: "inactive.agent@simcollect.gh",
    phone_number: "233241112288",
    admin_slug: "ops_u_009",
    role: ROLES.CALL_CENTER_AGENT,
    status: "inactive",
    last_login_at: "2026-07-12T11:20:00.000000Z",
    created_at: "2025-09-01T10:00:00.000000Z",
    status_reason: "Account deactivated by Super Admin pending HR clearance.",
  }),
];

let opsUsers = [...INITIAL_OPS_USERS];

export function listOpsUsers() {
  return [...opsUsers];
}

export function inviteOpsUser({ first_name, last_name, email, phone_number, role_slug, role, name }) {
  const slug = role ?? role_slug;
  const displayName =
    name?.trim() ||
    `${first_name ?? ""} ${last_name ?? ""}`.trim() ||
    email.split("@")[0];
  const createdAt = new Date().toISOString();
  const id = `ops_u_${String(nextId++).padStart(3, "0")}`;
  const user = buildLocalMember({
    id,
    first_name: first_name?.trim() || displayName.split(" ")[0] || "",
    last_name: last_name?.trim() || displayName.split(" ").slice(1).join(" ") || "",
    email: email.trim().toLowerCase(),
    phone_number: phone_number ? String(phone_number).replace(/^\+/, "") : "",
    admin_slug: id,
    role: slug,
    role_slug: role_slug || slug,
    status: "invited",
    last_login_at: null,
    created_at: createdAt,
  });
  user.permissions = getRolePermissions(slug);
  opsUsers = [...opsUsers, user];
  return user;
}

export function updateOpsUser(id, patch) {
  opsUsers = opsUsers.map((user) => {
    if (user.id !== id) return user;
    const nextRole = patch.role ?? user.role;
    const nextPermissions =
      patch.permissions ??
      (patch.role ? getRolePermissions(patch.role) : user.permissions);
    const next = {
      ...user,
      ...patch,
      role: nextRole,
      permissions: nextPermissions,
    };
    if (patch.phone_number != null) {
      next.phone_number = String(patch.phone_number).replace(/^\+/, "");
      next.phone = normalizePhoneNumber(next.phone_number);
    }
    if (patch.first_name != null || patch.last_name != null) {
      next.name = getOpsUserDisplayName(next);
    }
    return next;
  });
  return opsUsers.find((u) => u.id === id);
}

export function syncOpsUsersPermissionsForRole(role, permissions) {
  opsUsers = opsUsers.map((user) =>
    user.role === role ? { ...user, permissions: [...permissions] } : user
  );
}

export function resendOpsUserInvite(id) {
  const user = opsUsers.find((u) => u.id === id);
  if (!user) return null;
  return user;
}

export function deleteOpsUser(id) {
  const user = opsUsers.find((u) => u.id === id);
  if (!user) return false;
  if (user.role === ROLES.SUPER_ADMIN) return false;
  opsUsers = opsUsers.filter((item) => item.id !== id);
  return true;
}

export function listAssignableAgents() {
  return listOpsUsers().filter(
    (user) =>
      user.status === "active" &&
      (user.role === ROLES.CALL_CENTER_AGENT || user.role === ROLES.CALL_CENTER_MANAGER)
  );
}

export { getRoleLabel, ROLES };
